const productPageStyle = (theme) => ({
  width100: {
    width: "100%",
  },
  marginBottom: {
    marginBottom: "24px",
  },
  marginRight: {
    marginRight: "5px",
  },
  padding0: {
    padding: 0,
  },
  padding4: {
    padding: "4px",
  },
  padding5: {
    paddingLeft: "5px",
  },
  padding15: {
    padding: "15px",
  },
  padding20: {
    padding: "20px",
  },
  basicPadding: {
    padding: "15px 20px",
  },
  rightAlign: {
    float: "right",
  },
  reducedFont: {
    fontSize: "11px",
  },
  minFont: {
    fontSize: "9px",
  },
  fontSize10: {
    fontSize: "10px",
  },
  fontSize12: {
    fontSize: "12px",
  },
  fontSize12WithPointer: {
    fontSize: "12px",
    cursor: "pointer",
  },
  borderBottom: {
    borderBottom: "1px solid grey",
  },
  lightBorderBottom: {
    borderBottom: "1px solid #e5e5e5",
  },
  scrollbar: {
    overflowX: "hidden !important",
    width: "100%",
    height: "100%",
  },
  card: {
    margin: "5px 0px 5px 0px",
  },
  productSection: {
    ...theme.arrowItem,
  },
  arrowTipItem: {
    ...theme.arrowTipItem,
  },
  scheduleType: {
    ...theme.ellipsisLabel,
    fontFamily: "SparBd",
    fontSize: "16px",
  },
  productName: {
    ...theme.ellipsisLabel,
    fontSize: "14px",
  },
  quoteInfo: {
    "& $buttonStyle": {
      "& span": {
        flexDirection: "column",
        fontSize: "10px",
        textTransform: "lowercase",
      },
    },
    backgroundColor: (props) => (props.selected ? "#eaf4e9" : "white"),
  },
  assetSection: {
    paddingLeft: "20px",
  },
  assetLabel9: {
    fontSize: "9px",
    color: theme.palette.timColors.grayColor,
  },
  buttonStyle: {},
  viewHistoryButton: {
    textTransform: "lowercase",
  },
  searchBackground: {
    background: "#e5e5e5",
    padding: "15px 20px 20px 25px",
  },
  modificationInfo: {
    paddingBottom: "5px",
    fontSize: "11px",
    paddingTop: "4px",
  },
  paymentInfoWithResidual: {
    paddingLeft: "30px",
    paddingTop: "4px",
  },
  paymentInfoWithoutResidual: {
    paddingLeft: "30px",
    paddingTop: "15px",
  },
  gradientLine: {
    paddingLeft: "10px",
    paddingTop: "15px",
    width: "200px",
    float: "left",
    border: "2px solid",
    borderTop: "0",
    borderBottom: "0",
    borderImage:
      "linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(226, 226, 226, 1) 48%, rgba(255, 255, 255, 0) 100%)",
    borderImageSlice: "1",
  },
  dateWidth: {
    width: "max-content",
    fontSize: "11px",
  },
  iconStyle: {
    height: "30px",
    width: "30px",
  },
  editAdvancedButton: {
    paddingTop: "0px 6px",
    paddingBottom: "0px 6px",
    fontSize: "14px",
  },
  scheduleStyle: {
    fontSize: "11px",
    fontWeight: "bold",
    textAlign: "center",
  },
  scheduleHeaderStyle: {
    fontSize: "11px",
    fontWeight: "bold",
    textAlign: "center",
    background: "#666666",
    color: "white",
    minWidth: "130px",
  },
  scheduleCell: {
    height: "70px",
    width: "80px",
    maxWidth: "80px",
    maxHeight: "70px",
    border: "1px solid #e5e5e5",
    padding: 0,
    margin: 0,
  },
  checkBox: {
    padding: 0,
    color: "#008000",
  },
  paperDialog: {
    overflowY: "visible",
  },
  generalGridContainer: {
    borderRight: "1px solid #e5e5e5",
    margin: 0,
    padding: "0 30px 0 20px",
  },
  typography: {
    fontWeight: "bold",
  },
  optionsContainer: {
    backgroundColor: "#f8f8f8",
    width: "100%",
  },
  optionsBorder: {
    border: "1px solid grey",
    outlineStyle: "dashed",
    width: "100%",
  },
  optionDot: {
    fontSize: "12px",
    verticalAlign: "middle",
  },
  option: {
    width: "100%",
    height: "100%",
    backgroundColor: "white",
    borderRadius: "10px",
    paddingTop: "0px",
    marginTop: "5px",
    marginBottom: "5px",
  },
  basicDialogContent: (props) => {
    return {
      overflow: props.fullScreen ? "auto" : "hidden",
      overflowX: "hidden",
      width: props.fullScreen ? "100%" : "500px",
      maxHeight: props.fullScreen ? "100%" : "calc(100vh - 90px - 16px)",
      padding: "8px 5px 0 5px",
    };
  },
  advancedDialogContent: (props) => {
    return {
      overflow: props.fullScreen ? "auto" : "hidden",
      overflowX: "hidden",
      padding: "8px 0",
    };
  },
  dialogActions: {
    padding: "8px 16px 8px 16px",
  },
  editProductParams: (props) => {
    return {
      width: props.fullScreen ? "100%" : "500px",
      maxHeight: props.fullScreen ? "100%" : "calc(100vh - 90px - 16px)",
      paddingRight: "0px !important",
    };
  },
  advancedEditProductScheduleCells: (props) => {
    return {
      width: props.fullScreen ? "100%" : "1100px",
      maxHeight: props.fullScreen ? "100%" : "calc(100vh - 90px - 16px)",
      paddingLeft: "0px !important",
    };
  },
  scheduleCellsContainer: {
    width: "calc(100% + 10px)",
    padding: "0 10px",
  },
  monthHeaderCell: {
    height: "20px",
    width: "80px",
    maxHeight: "20px",
    maxWidth: "80px",
    textAlign: "center",
    padding: 0,
  },
  yearHeaderCell: {
    height: "70px",
    width: "50px",
    maxHeight: "70px",
    maxWidth: "50px",
    textAlign: "center",
    padding: 0,
  },
  scheduleTableCell: {
    height: "70px",
    width: "80px",
    maxHeight: "70px",
    maxWidth: "80px",
  },
  scheduleCellLabel: {
    fontSize: "10px",
    fontWeight: "bold",
  },
  scheduleTableCellGrid1: {
    textAlign: "center",
    width: "calc(100% - 6px)",
    margin: "0 3px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  scheduleTableCellGrid2: {
    width: "100%",
    height: "12px",
  },
  scheduleTableCellGrid3: (props) => {
    return {
      backgroundColor: props.downpaymentCell || props.residualCell ? "#ee0000" : "#666",
      textAlign: "center",
      width: "100%",
      margin: "0 2px",
      borderRadius: "2px",
      fontSize: "10px",
      color: "white",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: "0 2px",
    };
  },
  rootBtn: {
    hover: {
      backgroundColor: "transparent",
    },
  },
  moreOptionsBtn: {
    padding: "0px !important",
    minWidth: "unset",
    "& span": {
      margin: "0px",
    },
  },
  actionBtn: {
    fontSize: "11px",
    height: "28px",
    width: "100px",
    maxWidth: "100px",
    padding: "6px",
  },
  txtActionBtn: {
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  vatFinancingLabel: {
    fontSize: "14px",
  },
  modifiedInfo: {
    fontSize: "10px",
    backgroundColor: "#666",
    color: "white",
    textTransform: "lowercase",
    padding: "0 5px",
    borderRadius: "2px",
  },
  sliderRoot: {
    padding: 0,
  },
  sliderThumb: {
    width: "24px",
    height: "24px",
    marginTop: "-12px",
    marginLeft: "-12px",
  },
  confirmationItem: {
    backgroundColor: "green",
    color: "white",
    width: "100%",
    margin: "10px 0",
    padding: "12px 0 !important",
  },
  warning: {
    backgroundColor: "#d4b847",
    color: "white",
    width: "100%",
    margin: "10px 0",
    padding: "12px 0 !important",
  },
  warningIcon: {
    margin: "0 10px 0 10px",
    fontSize: "25px",
  },
  input: {
    textAlign: "right",
  },
  customSlider: {
    "& .MuiFormLabel-root": {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
    },
    "& div": {
      "& div": {
        "& label": {
          width: "133.33%",
          position: "relative",
        },
        "& div": {
          margin: "0px",
        },
      },
    },
  },
  customTextField: {
    "& label": {
      width: "133.33%",
      position: "relative",
    },
    "& div": {
      margin: "0px",
    },
  },
});

export default productPageStyle;
